'use client';

import { useCountryFromUrl } from '@frontend-tools/helpers/use-country-from-url';
import { pushEvent } from '@frontend-tools/utils/tracking/tracking';
import { ERROR_TRANSLATIONS, ErrorPage } from '@kavak/frontend-layout';
import { useEffect } from 'react';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const country = useCountryFromUrl();

  useEffect(() => {
    console.error('[Error Boundary] - Error caught by [supply-ui]:', {
      product: 'supply-ui',
      country,
      error: error.message,
      stack: error.stack,
      url: typeof window !== 'undefined' ? window.location.href : 'server-side',
    });

    pushEvent('error_viewed', {
      url: typeof window !== 'undefined' ? window.location.href : 'server-side',
      country,
      product: 'supply-ui',
    });
  }, [error.message, error.stack, country]);

  const translations = ERROR_TRANSLATIONS[country] || ERROR_TRANSLATIONS.mx;

  return (
    <ErrorPage
      type="error"
      title={translations.title}
      description={translations.description}
      subtitle={translations.subtitle}
      cta={translations.cta}
      reloadPage
    />
  );
}
